var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStarBlueFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5218 33.878C28.6718 33.96 28.8358 34 28.9998 34C29.2038 34 29.4078 33.936 29.5798 33.814C29.8898 33.592 30.0478 33.212 29.9858 32.834L28.0698 21.342L35.7058 13.706C35.9718 13.442 36.0658 13.052 35.9518 12.694C35.8378 12.336 35.5338 12.074 35.1638 12.012L23.6658 10.096L18.8938 0.552C18.7258 0.214 18.3778 0 17.9998 0C17.6218 0 17.2758 0.214 17.1058 0.552L12.3338 10.096L0.835779 12.012C0.465779 12.074 0.161779 12.338 0.0477787 12.694C-0.0662213 13.05 0.0297785 13.442 0.293778 13.706L7.92978 21.342L6.01378 32.834C5.94978 33.212 6.10778 33.592 6.41978 33.814C6.73178 34.036 7.14178 34.062 7.47778 33.878L17.9998 28.14L28.5218 33.878Z",
    fill: "#1BA2CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarBlueFull);
export default __webpack_public_path__ + "static/media/rating-star-blue-full.f868a6c22910d2a53ab9c21c27a564ad.svg";
export { ForwardRef as ReactComponent };